import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { Options } from '@/modules/promotion/code/model/mixins';
import { promotionService } from '@/services/promotion';
import { ref } from 'vue';

export function usePromotionCode() {
    const { confirmAndRemove, confirmAndDisable, confirmAndEnable } = useCrudActions();

    const featureId = ref(null);
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: promotionService.code.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        remove: confirmAndRemove({
            request: promotionService.code.remove,
            onSuccess: () => fetchList()
        }),
        enable: confirmAndEnable({
            request: promotionService.code.enable,
            onSuccess: () => fetchList()
        }),
        disable: confirmAndDisable({
            request: promotionService.code.disable,
            onSuccess: () => fetchList()
        })
    };

    return { featureId, list, total, query, actions, Options, fetchList };
}
